exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sync-charts__container {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/charts/synchronized-charts/synchronized-charts.component.css
// module id = ../../../../../src/app/shared/components/charts/synchronized-charts/synchronized-charts.component.css
// module chunks = main